import { UzMap } from '@/common/icons/UzMap';
import { Button } from '@/components/ui/button';
import { Reply } from 'lucide-react';

interface RegionMapProps {
  renderTooltip?: (regionId: string) => React.ReactNode;
  /** Berilsa, xarita ustida respublikaga qaytish tugmasi chiqadi. */
  onBack?: () => void;
}

/** Xarita va uning ustidagi boshqaruvlar. Maskanlar va klasterlar
 *  sahifalarida bir xil ishlatiladi. */
export const RegionMap = ({ renderTooltip, onBack }: RegionMapProps) => (
  <div className="relative flex h-full w-1/2 items-center justify-center">
    {onBack && (
      <Button
        className="absolute left-5 top-5 z-10 rounded-md border-white/10 p-2"
        variant="outline"
        onClick={onBack}
      >
        <Reply className="text-violet-500" size={20} />
      </Button>
    )}

    <UzMap renderTooltip={renderTooltip} />
  </div>
);
